import PayPal4 from './PayPal4'
export default PayPal4
